import { render, staticRenderFns } from "./CabinetsDashboard.vue?vue&type=template&id=4b825298&"
import script from "./CabinetsDashboard.vue?vue&type=script&lang=ts&"
export * from "./CabinetsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports